import { Component, Input, EventEmitter, Output, ElementRef, Renderer2, ViewChild } from '@angular/core';

@Component({
    selector: 'hub-loading-button',
    templateUrl: './hub-loading-button.component.html',
    styleUrls: ['./hub-loading-button.component.scss'],
})

export class HubLoadingButtonComponent {

    public displayButton: any = true;

    @Input() public goTo: string = '';
    @Input() public active: boolean = false;
    @Input() public set displayButtonRefresh(display: any) {
        if (display !== undefined || display !== null) {
            this.displayButton = (display) ? false : true;
        }
    }
    @Output() public clickEmitter: EventEmitter<any> = new EventEmitter();
    @ViewChild('hubLoadingButton', {static: true}) private hubLoadingButton;

    constructor(
        private elRef: ElementRef,
        private renderer: Renderer2,
    ) {
        if (!this.active) this.counter();
    }

    public refresh() {
        $('html, body')
            .animate({
                scrollTop: $(this.goTo)
                    .offset().top - 50,
            }, 800);

        this.active = false;
        this.counter();
        this.clickEmitter.emit({ type: 'refresh' });
    }

    private counter() {
        if (!this.active) {
            setTimeout(() => {
                this.active = true;
            }, 60000);
        }
    }
}
